(function ($, Drupal) {
  Drupal.behaviors.scrollToError = {
    attach: function (context) {
      const highlighted = context.querySelector('.highlighted');
      if (!highlighted) return;

      // Function to scroll to error message
      const checkAndScrollToError = () => {
        const alert = highlighted.querySelector('.alert[role="alert"]');
        if (alert) {
          requestAnimationFrame(() => {
            const offset = 300;
            const top = alert.getBoundingClientRect().top + window.scrollY - offset;
            window.scrollTo({ top: top, behavior: 'smooth' });
          });
        }
      };

      // Initialize observer
      const observer = new MutationObserver(checkAndScrollToError);
      observer.observe(highlighted, {
        childList: true,
        subtree: true,
        attributes: false,
        characterData: false
      });

      // Check immediately in case error exists on initial load
      checkAndScrollToError();
    }
  };
})(jQuery, Drupal);
